import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getProductsAddedToCartRequest, getProductsAddedToCartRequestError, getProductsAddedToCartRequestSuccess } from "../../slices/Cart/GetProductsAddedToCartSlice";

export const GetProductsAddedToCartApi = () => async (dispatch) => {
    try {
        dispatch(getProductsAddedToCartRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.productsAddedToCart,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getProductsAddedToCartRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getProductsAddedToCartRequestError(_error));
            });
    } catch (error) {
    }
};
